<template>
    <input
        type="text"
        :value="value"
        @input="clearError"
        @change="checkGermanDate"
        inputmode="numeric"
        pattern="\s*\d{2}.\d{2}.\d{4}\s*"
    />
</template>

<script>
export default {
    name: 'DateInput',

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        value: {
            required: true
        },

        allowFutureDates: Boolean,
        incorrectDateMessage: {
            type: String,
            default() {
                return this.$t && this.$t('Form.date.incorrectDate') || "Das eingegebene Datum ist falsch";
            }
        }
    },

    methods: {
        clearError(e) {
            const inputElement = e.target;
            // Need to clean up previous errors. Wil lbe rechecked on @change (blur) event
            inputElement.setCustomValidity('');
            inputElement.style.borderColor = '';
        },
        checkGermanDate(e) {
            const inputElement = e.target;
            const dateValue = (inputElement.value || '').trim();
            const isIncorrectPattern = !/\d{2}.\d{2}.\d{4}/.test(dateValue);

            const [dd, mm, yyyy] = dateValue.split('.');

            // Date.parse takes 31 for shorter months and 30 for February as correct next month dates, therefore:
            const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            // Adjust for leap years
            if (yyyy % 400 === 0 || (yyyy % 100 !== 0 && yyyy % 4 === 0)) {
                monthLength[1] = 29;
            }
            const isDayInMonth = dd <= monthLength[mm - 1];

            const parsedDate = Date.parse(`${yyyy}-${mm}-${dd}`);
            const isNonParsedDate = isNaN(parsedDate);

            const notAllowedDate = !this.allowFutureDates && parsedDate >= Date.now();

            if (isIncorrectPattern || !isDayInMonth || isNonParsedDate || notAllowedDate) {
                inputElement.style.borderColor = 'red';
                inputElement.setCustomValidity(this.incorrectDateMessage);
                inputElement.reportValidity();
            } else {
                inputElement.setCustomValidity('');
            }

            // custom component v-model necessary part
            // vue v-model specifics does require trim modifier application in the parent component
            this.$emit('change', dateValue);
        }
    }
};
</script>
